import {
  LngLat,
  Margin,
  YMapLocationRequest,
  YMapCenterZoomLocation
} from '@yandex/ymaps3-types';

export const DEFAULT_CLUSTER_GRID_SIZE = 128;
export const DEFAULT_ZOOM_VALUE = 12;
export const MIN_MAP_ZOOM = 3;
export const MAX_MAP_ZOOM = 21;
export const DEFAULT_SELECT_POINT_ZOOM_VALUE = 15;
export const DEFAULT_CENTER_VALUE: LngLat = [37.617698, 55.755864];
/** Запас по долготе/широте (в градусах) для начального вида карты по центру города */
export const CITY_CENTER_BOUNDS_PADDING = 0.03;
export const MARGIN: Margin = [100, 100, 100, 460];
export const MOBILE_MARGIN: Margin = [10, 10, 10, 10];

export const LOCATION: YMapCenterZoomLocation = {
  center: DEFAULT_CENTER_VALUE,
  zoom: DEFAULT_ZOOM_VALUE
};

/** Zoom карты до появления центра города */
export const NEUTRAL_MAP_ZOOM = DEFAULT_ZOOM_VALUE;

export const COMMON_LOCATION_PARAMS: Partial<YMapLocationRequest> = {
  easing: 'ease-in-out',
  duration: 1000
};
